import type {DataValue, PartCodeList} from 'schemaDefinition/types';
import type {CodeList} from 'services/codelists/types';
import type {LinkedRoleCodeList} from 'schemaDefinition/types/linkTypes';
import {formatNullValue} from './formatNullValue';

export const formatCodeListValue = (
  value: DataValue,
  part: PartCodeList,
  codeList: CodeList | LinkedRoleCodeList | undefined,
): string => {
  if (
    value === undefined ||
    value === null ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return formatNullValue();
  }

  switch (part.type) {
    case 'codelist': {
      const codes = Array.isArray(value) ? value : [value];
      return codes
        .map(code => {
          const codelistCode = codeList?.codes?.find(
            item => item.code === code,
          );

          // Either formatted value based on codelist
          if (codelistCode) {
            return (part.showCode ? `${code}: ` : ``) + codelistCode.value;
          }

          // or just code (will handle e.g. basedOnIsbn without local codelist)
          if (code) {
            return code;
          }

          return formatNullValue();
        })
        .join(', ');
    }
  }
};
